import { render } from "./Insurances.vue?vue&type=template&id=1beca706&scoped=true"
import script from "./Insurances.vue?vue&type=script&lang=js"
export * from "./Insurances.vue?vue&type=script&lang=js"

import "./Insurances.vue?vue&type=style&index=0&id=1beca706&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1beca706"]])

export default __exports__